export default "__VITE_ASSET__3aaa289d__"